// extracted by mini-css-extract-plugin
module.exports = {"phone-input-field":"phone-input-field___2zk8p","phone-input-label":"phone-input-label___1DT7_"};